import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "../../../../environments/environment";
import { Subject } from 'rxjs';
// import axios from 'axios';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private orderUrl = environment.apiUrl + "admin/order";
  private orderDeleteUrl = environment.apiUrl + "admin/order/delete-permntly";
  private orderOutOfDeliveryUrl = environment.apiUrl + "admin/order/outofdelivery";
  private orderDeliveredUrl = environment.apiUrl + "admin/order/delivered";
  private diversUrl = environment.apiUrl + "admin/divers";
  private paymentURL = environment.apiUrl + "admin/divers/updateOrder";
  private createOtpValida = environment.apiUrl + "admin/order/createOtp";
  private getPiechartDetails = environment.apiUrl + "admin/order/orders/getPiechartOrder";

  private notify = new Subject<any>();
  notifyObservable$ = this.notify.asObservable();

  constructor(private http: HttpClient) { }

  notifyOther(data: any){
    if(data) {
      this.notify.next(data);
    }
  }

  getOrderList(data: any) {
    return this.http.get(this.orderUrl, {
      headers: new HttpHeaders(), params: data
    })
  }

  getOrder(data: any) {
    return this.http.get(this.orderUrl + '/' + data, {
      headers: new HttpHeaders()
    });
  }

  getInprogressOrder(data: any) {
    return this.http.get(this.orderUrl + '/in-progress/' + data, {
      headers: new HttpHeaders()
    });
  }

  getCompleteOrder(data: any) {
    return this.http.get(this.orderUrl + '/complete/' + data, {
      headers: new HttpHeaders()
    });
  }

  getCancelOrder(data: any) {
    return this.http.get(this.orderUrl + '/cancel/' + data, {
      headers: new HttpHeaders()
    });
  }

  getRetailerList() {
    return this.http.get(this.diversUrl + '/retailer', {
      headers: new HttpHeaders()
    });
  }

  getProductList() {
    return this.http.get(this.diversUrl + '/product', {
      headers: new HttpHeaders()
    });
  }

  addOrder(data) {
    return this.http.post(this.orderUrl, data, {
      headers: new HttpHeaders 
    });
  }

  updateOrder(data) {
    return this.http.put(this.orderUrl, data, {
      headers: new HttpHeaders 
    });
  }

  updateOrderOutOfDelivery(data) {
    return this.http.post(this.orderOutOfDeliveryUrl, data, {
      headers: new HttpHeaders 
    });
  }

  updateDelivered(data) {
    return this.http.post(this.orderDeliveredUrl, data, {
      headers: new HttpHeaders 
    });
  }

  getPaymentOption() {
    return this.http.get(this.diversUrl + '/option', {
      headers: new HttpHeaders()
    });
  }

  processPaymentSuccess(data) {
    return this.http.post(this.diversUrl + '/payment', data, {
      headers: new HttpHeaders
    });
  }

  getPaymentSignature(data) {
    return this.http.get(this.diversUrl + '/signature', {
      headers: new HttpHeaders(), params: data
    });
  }

  updateRetailerCredits(data) {
    return this.http.post(this.diversUrl + '/update-payment', data, {
      headers: new HttpHeaders(), 
    });
  }

  deleteRetailer(data: any) {
    return this.http.delete(this.orderUrl, {
      headers: new HttpHeaders(), params: data
    });
  }

  deletePermanently(data: any) {
    return this.http.delete(this.orderDeleteUrl, {
      headers: new HttpHeaders(), params: data
    });
  }
  updateOrderOnline(data: any){
    return this.http.post(this.paymentURL, data,{
      headers: new HttpHeaders 
    })
  }

  createOtp(data) {
    return this.http.post(this.createOtpValida, data, {
      headers: new HttpHeaders 
    });
  }

  getOrderPieChart(){
    return this.http.get(this.getPiechartDetails, {
      headers: new HttpHeaders 
    });
  }

  // async cashFreePayment(data) {
  //   let paymentProcess = await axios.post('https://test.cashfree.com/billpay/checkout/post/generate-paymenthash', data, {});
  //   console.log('paymentProcess', paymentProcess);
  //   return paymentProcess;
  // }
}
